<ng-container *ngFor="let item of errors | keyvalue">
  <small class="p-error" *ngIf="showErrorMsg(item.key)">
    {{ item.value }}
  </small>
</ng-container>
